<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full" >
        <div 
          v-for="(data, index) in data_local.selfiedata" 
          style="display: flex; align-items: center; justify-content: space-between;">
          <table>
            <tr style="width: 100%">
              <td style="width:150px;">
                <img :src="data.url" style="width:120px; height:120px; border-radius: 10px;"/>
              </td>
              <td style="width:70px" class="isDesk"> 
                <vs-avatar
                  :src="
                    data_local.userdata.avatar
                      ? `https://selfie.cash/avatar/${data_local.userdata.avatar}`
                      : require('@/assets/images/avatar.png')"
                  size="50px"
                  class="border-2 border-white border-solid -m-1"
                ></vs-avatar> </td>
              <td class="selfiePrice isDesk">
                {{'€' + data.price }}
              </td>
              <td class="isDesk"> 
                <p class="selfieTitle">{{ data.title}}</p> 
                <p class="selfieDes">{{ data.description }}</p> 
              </td>
            </tr>
          </table>
          <div>
            <vx-tooltip v-if="data.status==`Rejected`" :text='data.statusComment' position="top" style="cursor: pointer;">
              <vs-chip  :color="chipColor(data.status)">
                <span>{{ status(data.status) }}</span>
               </vs-chip>
            </vx-tooltip>
            <vs-chip v-else :color="chipColor(data.status)">
              <span>{{ status(data.status) }}</span>
            </vs-chip>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    },
    chipColor (value) {
      return (value) => {
        if (value === 'Rejected' ) return 'danger'
        else if (value === 'Approved') return 'success'
        else return "primary"
      }
    },
    status (value) {
      return (value) => {
        if (value === 'Approved' ) return 'Approved'
        else if (value === 'Rejected' ) return 'Rejected'
        else return 'Pending'
      }
    }
  },
  methods: {
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data (Also remvoe eslint-disable)
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data () {
      this.data_local = Object.assign({}, this.data)
    }
  }
}
</script>
<style>
.selfieTitle {
  font-size: 20px;
}
.selfieDes {
  font-size: 15px;
}
.selfiePrice {
  width: 70px;
  font-size: 20px;
  text-align: left;
  align-items: center
}
@media only screen and (max-width:768px) {
  .isDesk {
    display: none;
  }
  
}
</style>